import { Box } from "@mui/material";
import React from "react";
import SideNav from "../../../agentComponents/sidenav";
import CampaignSync from "./CampaignSync";

const CampaignSyncView = () => {
    return (
        <div>
            <Box
                sx={{
                    display: "flex",
                    p: {
                        xs: "50px 0 0 0",
                        md: "50px 20px",
                    },
                    bgcolor: "white",
                }}
            >
                <SideNav />
                <Box sx={{ width: "100%" }}>
                    <CampaignSync />
                </Box>
            </Box>
        </div>
    );
};

export default CampaignSyncView;
